import { useSeparator } from '@react-aria/separator'
import Styles from './Separator.module.scss'

export const Separator = () => {
  const { separatorProps } = useSeparator({
    elementType: 'li',
  })

  return <li {...separatorProps} className={Styles.separator} />
}
